import { IBaseState, IBaseAction, TAppError } from '@/store/types/base.state';

import { ICursorElements } from '@/store/types/search.types';

import { ICardTransaction } from '@/features/cards/store/models/card.model';
import {
  ICheckField,
  ILookupField,
  IPeriodField,
  IRangeField,
  ISearch,
  ISearchField,
  TPeriodBasesType,
  TRangeBasesType,
} from '@/ui-kit/table-filters/filters.type';

export enum CardTransactionActionTypes {
  GET_CARD_TRANSACTIONS = 'CARD_TRANSACTION.GET_CARD_TRANSACTIONS',
  GET_CARD_TRANSACTIONS_SUCCESS = 'CARD_TRANSACTION.GET_CARD_TRANSACTIONS_SUCCESS',
  GET_CARD_TRANSACTIONS_FAIL = 'CARD_TRANSACTION.GET_CARD_TRANSACTIONS_FAIL',
}

export interface IGetCardTransactionAction extends IBaseAction {
  type: typeof CardTransactionActionTypes.GET_CARD_TRANSACTIONS;
}

export interface IGetCardTransactionSuccessAction extends IBaseAction {
  type: typeof CardTransactionActionTypes.GET_CARD_TRANSACTIONS_SUCCESS;
  paginateCardTransactions: ICursorElements<ICardTransaction>;
}

export interface IGetCardTransactionFailAction extends IBaseAction {
  type: typeof CardTransactionActionTypes.GET_CARD_TRANSACTIONS_FAIL;
  error: TAppError;
}

export type TCardTransactionAction =
  | IGetCardTransactionAction
  | IGetCardTransactionFailAction
  | IGetCardTransactionSuccessAction;

export interface ICardTransactionState extends IBaseState {
  paginateCardTransactions: ICursorElements<ICardTransaction>;
}

export interface ICardTransactionFilterFormFields {
  search?: ISearch;
  status?: string[];
  mcc?: string;
  mid?: string;
  createdDate?: {
    from: string;
    to: string;
    base: TPeriodBasesType;
  };
  amount?: {
    from?: string;
    to?: string;
    base?: TRangeBasesType;
  };
  paymentTypes?: string[];
}

export type TCardTransactionFilterFields = {
  search?: ISearchField;
  createdDate: IPeriodField;
  amount?: IRangeField;
  status?: ICheckField;
  mcc?: ILookupField;
  mid?: ILookupField;
  paymentTypes?: ICheckField;
};
